module.exports = __webpack_public_path__ + "img/whatsapp.cfaa8847.png";